import React from 'react';
import { useSidebar } from '../../../context/SidebarContext';
import { useBreadcrumb } from '../../../context/BreadcrumbContext';
import SummaryCards from './components/SummaryCards';
import PlanCard from './components/PlanCard';
import ShiftRequestsCard from './components/ShiftRequestsCard';
import WeeklyWorkerActivity from './components/WeeklyWorkerActivity';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../store';
import { 
  fetchOrgSummary, 
  fetchOrgShiftRequests, 
  fetchOrgWeeklyActivity, 
  fetchOrgPlan 
} from '../../../modules/orgDashboard';

import {
  DashboardContainer,
  DashboardGrid
} from './style';

const OrgDashboard: React.FC = () => {
  const { setActivePage, setIsCollapsed } = useSidebar();
  const { setIsShow } = useBreadcrumb();
  const dispatch = useDispatch<AppDispatch>();

  React.useEffect(() => {
    setActivePage('dashboard');
    setIsShow(false);
    setIsCollapsed(false);
    dispatch(fetchOrgSummary());
    dispatch(fetchOrgShiftRequests('This Week'));
    dispatch(fetchOrgWeeklyActivity());
    dispatch(fetchOrgPlan());
  }, [setActivePage, setIsShow, setIsCollapsed, dispatch]);

  return (
    <DashboardContainer>
      <DashboardGrid>
        <SummaryCards />
        
        <PlanCard />
        
        <ShiftRequestsCard />
        
        <WeeklyWorkerActivity />
      </DashboardGrid>
    </DashboardContainer>
  );
};

export default OrgDashboard;
